import { render, staticRenderFns } from "./CourseSubject.vue?vue&type=template&id=428ca9c6&scoped=true"
import script from "./CourseSubject.vue?vue&type=script&lang=js"
export * from "./CourseSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ca9c6",
  null
  
)

export default component.exports